import React from 'react';
import { useSelector } from "react-redux";
import { selectExistingMeetingRoomBooking, selectMeetingRoom } from "../../models/meeting-room-booking-dialog.duck";
import { BodyRegular } from '@shared/ui/atoms/fonts/Body';
import { MeetingRoomStatus, RoomBookingSource } from "../../models/MeetingRooms";

export function MeetingRoomBookingTabDebugView(props: Props) {
  const existingMeetingRoomBooking = useSelector(selectExistingMeetingRoomBooking);
  const meetingRoom = useSelector(selectMeetingRoom);

  return (
    <>
      <div style={{marginBottom: 24}}>
        <BodyRegular weight={600}>{existingMeetingRoomBooking?.source}</BodyRegular>
        {existingMeetingRoomBooking?.source === RoomBookingSource.TEAM_TODAY && <BodyRegular>a Team Today meeting room booking in a Team Today meeting room</BodyRegular>}
        {existingMeetingRoomBooking?.source === RoomBookingSource.OUTLOOK && <BodyRegular>an outlook booking, made in outlook with no record in Team Today</BodyRegular>}
        {existingMeetingRoomBooking?.source === RoomBookingSource.SYSTEM_LINKED_TO_OUTLOOK && <BodyRegular>an outlook booking, made in Team Today with a matched Outlook booking</BodyRegular>}
        {existingMeetingRoomBooking?.source === RoomBookingSource.EDITED_SYSTEM_LINKED_TO_OUTLOOK && <BodyRegular>an outlook booking, made in Team Today with a matched Outlook booking but it has been edited</BodyRegular>}
        {existingMeetingRoomBooking?.source === RoomBookingSource.TEAM_TODAY && !!meetingRoom?.microsoftRoomId && <BodyRegular weight={600}>Error: Shouldn't have a TeamToday booking in an Outlook meeting room</BodyRegular>}
      </div>
      <div style={{marginBottom: 24}}>
        <BodyRegular weight={600}>{existingMeetingRoomBooking?.status}</BodyRegular>
        {existingMeetingRoomBooking?.status === MeetingRoomStatus.PENDING && <BodyRegular>No longer relevant, shouldn't be here</BodyRegular>}
        {existingMeetingRoomBooking?.status === MeetingRoomStatus.PENDING && <BodyRegular>No longer relevant, shouldn't be here</BodyRegular>}
        {existingMeetingRoomBooking?.status === MeetingRoomStatus.COMPLETE && <BodyRegular>Successfully wrote to TT or MS</BodyRegular>}
        {existingMeetingRoomBooking?.status === MeetingRoomStatus.FAILED && <BodyRegular></BodyRegular>}
        {existingMeetingRoomBooking?.status === MeetingRoomStatus.NOT_BOOKED && <BodyRegular></BodyRegular>}
      </div>
      <div style={{marginBottom: 24}}>
        <pre>{JSON.stringify(existingMeetingRoomBooking, undefined, 2)}</pre>
      </div>
    </>
  )
}

interface Props {
  userCanSaveBooking: boolean;
}
